document.addEventListener('DOMContentLoaded', () => {
  // Setup elements
  const dialog = document.getElementById('zipCoverageDialog');
  const openBtn = document.querySelectorAll('[data-open-zip-coverage-dialog]');
  const closeBtns = dialog.querySelectorAll('[data-close-dialog]');
  const zipForm = dialog.querySelector('zip-coverage');

  // Open dialog handler
  const openDialog = () => {
    zipForm?.reset();
    dialog.classList.remove('animate-dialog-open');

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      // Fallback for browsers that do not support dialog.showModal()
      dialog.style.display = 'block';
    }

    // Animate the dialog after it's opened
    requestAnimationFrame(() => {
      dialog.classList.add('animate-dialog-open');
    });
  };

  // Open dialog when the open button is clicked
  openBtn.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openDialog();
    });
  });

  // Close dialog when the close button is clicked
  closeBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      dialog.close();
    });
  });

  // Close dialog when clicking outside of it
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) {
      dialog.close();
    }
  });
});
